export const createSelectOptions = (options) => options.map((a) => ({ value: a, label: a }));

export const createValueList = (values, options) =>
  values.map((c) => options.find((o) => o.value === c)).filter((o) => !!o);
